import React, { useState, useEffect } from 'react';
import { Link } from "react-router-dom";
import { db, auth } from '../Firebase_Config/firebase';
import { collection, query, where, getDocs } from 'firebase/firestore';
import { FaUser } from 'react-icons/fa';
import Alert from '@mui/material/Alert';
import { SiTarget } from "react-icons/si";
import './admin.css';
import Copyright from '../CopyrightFooter/Copyright';

const AdminDashboard = () => {
    const [users, setUsers] = useState([]);
    const [adminTrue, setAdminTrue] = useState(null);
    const [averageRiskScore, setAverageRiskScore] = useState(0);
    const [adminOrgName, setAdminOrgName] = useState('');
    //Fetches all non Admin users
    useEffect(() => {
        const fetchAdminAndUsers = async () => {
            try {
                const userId = getUserId();
        
                const normalizeString = (str) => {
                    return (str || '')
                        .toLowerCase()
                        .replace(/[^a-z0-9]/g, '');
                };
        
                // Fetch admin info
                const userDocQuery = query(collection(db, 'users'), where('userId', '==', userId));
                const userDocSnapshot = await getDocs(userDocQuery);
        
                let PreAdminOrgName = '';
                if (!userDocSnapshot.empty) {
                    const userDocData = userDocSnapshot.docs[0].data();
                    const isAdminTrue = userDocData.isAdmin || null;
                    setAdminTrue(isAdminTrue);
                    PreAdminOrgName = userDocData.OrganName || '';
                    setAdminOrgName(PreAdminOrgName)
                } else {
                    console.log('User document not found for user ID:', userId);
                    return;
                }
        
                const normalizedAdminOrg = normalizeString(PreAdminOrgName);
        
                // Fetch non-admin users
                const usersRef = collection(db, 'users');
                const q = query(usersRef, where('isAdmin', '==', false));
                const querySnapshot = await getDocs(q);
        
                const fetchedUsers = [];
                let totalScore = 0;
                let scoreCount = 0;
        
                querySnapshot.forEach(doc => {
                    const data = doc.data();
                    const userOrgName = data.OrganName || '';
                    const normalizedUserOrg = normalizeString(userOrgName);
        
                    if (normalizedUserOrg === normalizedAdminOrg) {
                        fetchedUsers.push({ id: doc.id, ...data });
        
                        // Add CyberRiskScore to total if it's a valid number
                        const score = parseFloat(data.OverallConformityScore);
                        if (!isNaN(score)) {
                            totalScore += score;
                            scoreCount++;
                        }
                    }
                });
        
                setUsers(fetchedUsers);
        
                if (scoreCount > 0) {
                    const averageScore = totalScore / scoreCount;
                    setAverageRiskScore(averageScore); // you need to define this setter in your component
                } else {
                    setAverageRiskScore(0);
                }
        
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };
        fetchAdminAndUsers();
    }, []);

    const getUserId = () => {
        const user = auth.currentUser;
        return user.uid;
    };

    const getRiskClass = (score) => {
        if (score >= 70) return 'low-risk';
        if (score >= 40) return 'medium-risk';
        return 'high-risk';
      };

    return (
        <div className='adminBG'  >
            {adminTrue ? (
                <div className='Admincontent'>
                    <div className='Adminheader'  >
                        
                        <h1>Administrator Dashboard</h1>
                    </div>
                    <br/>
                    <Alert variant="outlined" severity="warning">Admins have full access to users assessments. So any changes that Admins make will affects users and they will see those changes.</Alert>
                    <br/>
                    <br/>
                    <div className='centerstatsbox'>
                        <div className="Admin-stats-box">
                            <div className="Admin-icon-box red">
                            <SiTarget />
                            </div>
                            <br/>
                            <div className="Admin-content-box centerText">
                            <h4>Average Conformity Score for</h4>
                            <h4>{adminOrgName}:</h4>
                            <p className={`average-score-highlight ${getRiskClass(averageRiskScore)}`}>
                                {averageRiskScore.toFixed(2)}%
                            </p>
                            </div>
                        </div>
                    </div>
                    <div className='admin-card-accent'/>
                    <h2 className='h2Color'>List of Users for {adminOrgName}:</h2>
                    <br/>
                    <div className="userCardGrid">
                    {users.map(user => (
                        <div className="Admin-stats-box userCard" key={user.id}>
                            <div className="Admin-icon-box red">
                                <FaUser />
                            </div>
                            <div className="Admin-content-box">
                                <h4>Name: {user.Name}</h4>
                                <h4>Role: {user.RoleTitle}</h4>
                                <h4>
                                    Conformity Score:
                                    <span className={`risk-score-tag ${getRiskClass(user.OverallConformityScore)}`}>
                                        {user.OverallConformityScore.toFixed(2)}%
                                    </span>
                                </h4>
                                <div className="buttonGrid">
                                    {user.isConformityComplete && (
                                            <Link to={{ pathname: "/AdminDashboard/AdminConformityPage", search: `?id=${user.userId}` }}>
                                                <button className="AssessmentDashButton" size="small">
                                                    Conformity Page
                                                </button>
                                            </Link>
                                        )}
                                        {user.isThreatComplete && (
                                            <Link to={{ pathname: "/AdminDashboard/AdminThreatPage", search: `?id=${user.userId}` }}>
                                                <button className="AssessmentDashButton" size="small">
                                                    Threat Page
                                                </button>
                                            </Link>
                                        )}
                                        {user.isThreatComplete && (
                                            <Link to={{ pathname: "/AdminDashboard/AdminDashDash", search: `?id=${user.userId}` }}>
                                                <button className="AssessmentDashButton" size="small">
                                                    Dashboard Page
                                                </button>
                                            </Link>
                                        )}
                                </div>
                            </div>
                        </div>
                    ))}
                    </div>
                </div>
            ) : (
                <div className='Admincontent'>
                    <h1>You do not have Admin Permissions</h1>
                </div>
            )}
            <Copyright/>
        </div>
    );
};

export default AdminDashboard;
